import { render, staticRenderFns } from "./ReservasList.vue?vue&type=template&id=af4d92dc&"
import script from "./ReservasList.vue?vue&type=script&lang=js&"
export * from "./ReservasList.vue?vue&type=script&lang=js&"
import style0 from "./ReservasList.vue?vue&type=style&index=0&id=af4d92dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports